{
  "sv": {
    "translation": {
      "your-trip": "Din Resa",
      "edit-your-trip": "Ändra din Resa",
      "edit-fields-expiration-warning": "Vissa fält kan inte längre ändras om {{time}}",
      "edit-fields-expiration-subtext": "Spara dina ändringar eller de kan låsas",
      "edit-fields-no-changes-title": "Kan inte göra ändringar",
      "edit-fields-no-changes-message": "Det är inte längre möjligt att göra några ändringar i denna bokning.",
      "header-where-do-you-want-to-go": "Vart vill du åka?",
      "header-book-taxi": "Boka taxi",
      "placeholder-origin-location": "Jag vill resa från...",
      "placeholder-destination-location": "Jag vill resa till...",
      "placeholder-add-stop": "Lägg till ett stopp",
      "button-add-stop": "Lägg till ett stopp",
      "button-go-now": "Åka nu",
      "button-go-later": "Förboka",
      "button-no-available-cars": "Inga tillgängliga bilar",
      "booking-login-info": "För att slutföra din bokning kommer det att krävas att du bekräftar ditt telefonnummer i slutfasen av bokningen.",
      "validation-departure-required": "Du måste välja en upphämtningsplats.",
      "validation-destination-required": "Du måste välja en destination.",
      "validation-airport-not-allowed": "Du kan inte välja en flygplats som en viaadress.",
      "validation-departure-invalid": "Vi kan tyvärr inte hämta upp på denna address",
      "validation-destination-invalid": "Vi kan tyvärr inte stanna på denna address",
      "validation-intermediate-invalid": "Ogiltig som via-adress",
      "info-enter-street-number": "Vänligen fyll<br/>i gatunummer",
      "error-no-estimate": "Det verkar som du har dålig uppkopling, var vänlig försök igen eller ring vår växel 08-15 00 00 så hjälper de dig att boka.",
      "info-select-redirect": "Vänligen välj en alternativ plats.",
      
      "header-when-do-you-want-to-go": "När vill du åka?",
      "header-when-does-your-flight-land": "När landar ditt flyg?",
      "flightnumber-info": "Du kan vanligtvis hitta ditt flygnummer på din biljett eller bokningsbekräftlese.",
      "button-continue": "Fortsätt",
      "placeholder-flight-number": "Flightnummer",
      "placeholder-pick-date": "Välj landningstid",
      "info-flight-number": "Vi bevakar flygets ankomsttid",
      "title-baggage": "Incheckat baggage",
      "info-baggage": "Vi tar hänsyn till att det kan ta tid att få ditt incheckade bagage i handen efter landning",
      "section-flight-number": "Flygnummer",
      "section-landing-time": "Landningstid",
      "section-luggage": "Bagage",
      "header-passengers": "Passagerare",
      "label-passenger-count": "{{count}} passagerare",
      "label-group-size": "Antal passagerare",
      "info-passenger-count": "Leverantören behöver veta hur många passagerare ni är i bilen. Ni kan dela denna resa med andra passagerare.",
      "validation-need-passenger-count": "Ange antal passagerare",
      "modal-passenger-required-title": "Passagerare krävs",
      "modal-passenger-required-body": "Vänligen ange hur många ni är som reser.",
      "validation-date-not-valid": "Datum och tid är inte giltigt.",
      "validation-date-too-far-ahead": "Datum och tid är för långt fram.",
      "validation-need-date": "Du måste välja en dag och tid.",
      "validation-need-flight-number": "Vänligen fyll i ett giltigt flightnummer, (t.ex., AB123, A1B234, 1A999Z)",
      "title-invalid-time": "Ogiltig tid",
      "message-invalid-time": "Den valda tiden är inte tillgänglig och har justerats till närmast möjliga tid.",
      "title-fully-booked": "Tiden är fullbokad",
      "message-select-other-time": "Just nu är förbokningar fullbokade minst en timme framåt via webben, om möjligt välj en annan tid eller kontakta vår växel på 08-15 00 00 så hjälper de dig.",
      "message-select-next-available-time": "Välj en annan tid eller den föreslagna tiden.<br/><br/>Nästa lediga tid är {{time}}",
      "button-select-other-time": "Välj annan tid",
      "button-select-available-time": "Välj föreslagen tid",
      "button-ok": "Ok",

      "header-how-do-you-want-to-go": "Hur vill du åka?",
      "header-select-car": "Välj bil",
      "header-select-partner": "Välj partner",
      "header-no-providers-found": "Inga partners hittades",
      "info-no-providers-found": "Ingen partner matchar ditt val. Prova att ändra tillval eller biltyp.",
      "cartype-taxi": "Standardtaxi",
      "cartype-large-car": "Storbil",
      "cartype-estate": "Kombi",
      "cartype-business": "Business",
      "cartype-taxi-info": "För dina vardagliga resor",
      "cartype-large-car-info": "För större grupper",
      "cartype-estate-info": "Mer lastutrymme",
      "cartype-business-info": "Premiumtaxi",
      "num-persons-3": "3 personer",
      "num-persons-4": "4 personer",
      "num-persons-7": "7 personer",
      "approx-min": "ca {{minutes}} min",
      "title-fixed-price": "Fastpris",
      "info-fixed-price-not-available": "Fastpris är inte tillgängligt",
      "info-taxameter-not-available": "Taxameter är inte tillgängligt",
      "title-private-or-company": "Privat eller företagsresa",
      "info-private": "Privat",
      "title-booking-options": "Tillval",
      "info-booking-options": "Lägg till extra tillval",
      "label-luggage-fits": "Osäker om ditt bagage får plats?",
      "title-pet-option": "Resa med djur",
      "title-low-option": "Låg bil",
      "info-low-option": "Lättare att ta sig in och ut",
      "info-pet-option": "Tänk på att välja en stor bil om det behövs",
      "title-stationwagon-option": "Kombi",
      "title-childseat-option": "Bakåtvänd bilbarnstol",
      "info-childseat-option": "För barn minst 9 månader eller 9kg",
      "title-booster-option": "Bälteskudde",
      "info-booster-option": "För barn minst 4 år eller 15kg",
      "title-electric-car": "Elbil",
      "info-electric-car": "Om tillgängligt, föredrar jag en elbil",
      "button-done": "Klar",

      "label-i-want-to-go-now": "Direktbokning",
      "label-direct-booking": "Direktbokning",
      "label-prebooked": "Förbokning",
      "info-flight-monitoring": "Vi bevakar flygets ankomsttid",
      "label-checked-baggage": "Incheckat bagage",
      "label-from": "Från",
      "label-to": "Till",
      "label-when": "När",
      "label-payment": "Betalning",
      "label-receipt": "Kvitto",
      "label-how": "Hur",
      "label-fixed-price": "Fastpris",
      "label-taxameter": "Taxameter",
      "label-price-information": "Prisinformation",
      "label-total": "Totalt",
      "label-incl-tip": "inkl. dricks",
      "label-pet-option": "Resa med djur",
      "label-low-option": "Låg bil",
      "label-stationwagon-option": "Kombi",
      "label-childseat-option": "Bakåtvänd bilbarnstol",
      "label-booster-1-option": "1 bälteskudde",
      "label-booster-2-option": "2 bälteskuddar",
      "label-electric-option": "Elbil",
      "label-option-free": "Gratis",
      "label-booking-number": "Bokningsnummer",
      "info-available-in": "Tillgänglig om ca {{minutes}} minuter",
      "button-download-receipt": "Visa kvitto",
      "info-receipt-not-available": "Kvitto ej tillgängligt",
      "info-receipt-pending": "Kvitto tillgängligt efter registrerad betalning",
      "info-receipt-refunded": "Återbetalning genomförd",
      "info-num-vouchers_one": "{{count}} rabattkod tillgänglig",
      "info-num-vouchers_other": "{{count}} rabattkoder tillgängliga",

      "header-welcome": "Välkommen!",
      "info-welcome-subtitle": "Res säkert med Stockholms mest erfarna taxibolag",
      "label-phone-number": "Telefonnummer",
      "button-login-apple": "Fortsätt med Apple",
      "button-login-google": "Fortsätt med Google",
      "button-login-apple": "Fortsätt med Apple",
      "label-or": "eller",
      "info-by-continuing-terms": "Genom att fortsätta godkänner du våra <link1>Villkor</link1>",

      "header-google-signin": "Logga in med Google",
      "info-google-signin": "Logga in med ditt Google-konto för att fortsätta.",
      "error-google-signin-failed": "Det gick inte att logga in med Google. Försök igen.",
      "error-apple-signin-failed": "Det gick inte att logga in med Apple. Försök igen.",

      "header-add-phone-social": "Ditt telefonnummer",
      "info-add-phone-social": "Vi använder ditt nummer ifall vi behöver kontakta dig angående din resa. Vi skickar en verifieringslänk till dig.",
      "info-enter-code-sent-social": "Skriv in koden som skickades till nummer {{dialCode}} {{phone}}",

      "header-is-this-you": "Är det du?",
      "header-login-as": "Logga in som {{name}}?",
      "info-existing-account-found": "Vi hittade ett befintligt konto som använder samma telefonnummer som du angett.",
      "button-not-me": "Det är inte jag",
      "button-yes-thats-me": "Ja, det är jag",
      "button-create-new-account": "Skapa nytt konto",

      "header-confirm-phone": "Bekräfta ditt telefonnummer",
      "info-confirm-phone": "En kod kommer att skickas till ditt nummer. Vi använder ditt nummer för att smsa dig om viktiga uppdateringar på din resa.",
      "info-confirm-phone-login": "För att logga in måste du bekräfta ditt telefonnummer.",
      "button-cancel": "Avbryt",
      "validation-only-numbers": "Får bara innehålla siffror.",
      "validation-need-phone": "Du måste fylla i telefonnummer.",
      "validation-length-phone": "Måste vara mellan 6 och 14 siffor.",

      "header-enter-your-code": "Skriv in din kod",
      "info-enter-the-code-sent-to": "Skriv in koden som skickades till nummer {{dialCode}} {{phone}}",
      "button-did-not-get-code": "Jag fick ingen kod",

      "header-enter-your-email": "Ange din epostadress",
      "placeholder-enter-your-email": "Ange din epostadress",
      "info-we-use-your-email": "Vi använder din e-post för att logga in dig. Vi skickar en verifieringslänk till dig.",
      "validation-invalid-email": "Ogiltig epostadress.",
      "validation-need-email": "Du måste fylla i epostadress.",

      "header-welcome-back": "Välkommen tillbaka!",
      "info-your-phone-is-linked": "Ditt telefonnummer är länkat till epostadressen {{maskedEmail}}. Vänligen ange verifieringskoden som vi har mailat dig.",
      "button-select-other-email": "Välj annan epost",
      "change-email-message": "Om du loggar in med en annan epostadress kommer bokningar du gjort med din tidigare adress inte synas i din historik.",

      "header-enter-name": "Ange ditt namn",
      "info-driver-confirm-pickup": "Detta hjälper vår chaufför att bekräfta att det är du när de hämtar dig.",
      "placeholder-firstname": "Förnamn",
      "placeholder-lastname": "Efternamn",
      "validation-need-firstname": "Du måste fylla i förnamn.",
      "validation-need-lastname": "Du måste fylla i efternamn.",

      "header-terms-and-conditions": "Regler och villkor",
      "info-accept-terms": "Vänligen läs och godkänn våra <link1>regler och villkor</link1>.",
      "title-accept-terms": "Jag bekräftar att jag läst och accepterar vilkoren",
      "title-accept-marketing": "Jag vill få erbjudanden, nyheter och uppdateringar från Taxi Stockholm",
      "button-confirm": "Fortsätt",

      "header-confirm-your-booking": "Betala och bekräfta",
      "header-confirm-edit": "Bekräfta ändring",
      "placeholder-name": "Namn",
      "placeholder-phone": "Telefonnummer",
      "title-payment": "Betalning",
      "title-vouchers": "Rabattkoder",
      "title-voucher": "Rabattkod:",
      "title-pay-in-car": "Betala i taxin",
      "title-pay-in-car-sender": "Betala i taxin (avsändaren betalar)",
      "button-add-new-card": "Lägg till nytt betalkort",
      "button-add-new-account": "Lägg till nytt konto",
      "button-add-new-voucher": "Lägg till ny rabattkod",
      "title-message-to-driver": "Meddelande till föraren",
      "info-message-to-driver": "Här kan du beskriva hur föraren kan hitta dig.",
      "placeholder-reference": "Referens",
      "info-accept-booking-terms": "Genom att resa med oss så godkänner du våra <link1>resevillkor</link1>.",
      "title-message": "Meddelande",
      "validation-need-name": "Du måste fylla i namn.",
      "validation-need-reference": "Du måste fylla i referens.",
      "validation-need-payment": "Du måste välja betalsätt.",
      "button-book-now": "Bekräfta bokning",
      "button-confirm-edit": "Bekräfta ändring",
      "error-payment": "Något gick fel med betalningen. Vänligen försök igen.",
      "error-network": "Ingen kontakt med servern. Kontrollera din uppkoppling och försök igen.",
      "error-network-uncertain": "Vi kunde inte bekräfta om din bokning gick igenom. Kontrollera dina aktiva bokningar innan du försöker boka igen.",

      "header-whos-travel": "Resenär",
      "button-edit-booking": "Ändra bokning",
      "button-cancel-booking": "Avboka",
      "button-close": "Stäng",
      "button-book-again": "Boka resa igen",
      "button-return-trip": "Boka returresa",
      "button-add-to-calendar": "Lägg till i kalender",
      "button-forward-confirmation": "Vidarebefordra bokningsbekräftelse",
      "button-modify-booking": "Ändra bokning",
      "button-receipt-unavailable": "Kvitto ej tillgängligt",
      "header-price-change": "Priset har ändrats",
      "info-price-change": "Det nya priset för din bokning är {{newPrice}} kr. Vill du acceptera det nya priset?",
      "button-accept-price": "Acceptera nytt pris",
      "button-reject-price": "Avbryt",
      "label-name": "Namn",
      "label-phone": "Telefonnummer",
      "label-message-to-driver": "Meddelande till föraren",
      "header-thanks-for-your-booking": "Tack för din bokning!",
      "info-booking-done": "Du hittar dina bokningar under den gula ikonen uppe till höger. Genom att resa med oss så godkänner du våra <link1>resevillkor</link1>.",
      "title-car-and-eta": "{{taxi}} - ({{vehicle}}) ankommer ca {{eta}}",
      "title-car": "{{taxi}} - ({{vehicle}})",
      
      "tooltip-here-is-your-bookings": "Här finns dina bokningar",
      "header-your-bookings": "Dina bokningar",
      "info-arrives-apx": "Ca:",
      "label-date": "Datum",
      "label-flight-number": "Flightnummer",
      "label-baggage": "Bagage",
      "label-account": "Konto",
      "label-company-trip": "Företagsresa",
      "label-private-trip": "Privatresa",
      "label-booking-options": "Tillval",
      "label-yes": "Ja",
      "label-no": "Nej",
      "label-message": "Meddelande",
      "button-show-more": "Visa mer",
      "button-show-less": "Visa mindre",

      "info-login-to-update-profile": "Logga in för att lägga till betalmedel, se resehistorik eller uppdatera din profil.",
      "label-firstname": "Förnamn",
      "label-lastname": "Efternamn",
      "label-mobile-phone": "Mobiltelefon",
      "label-not-verified": "Ej verifierad",
      "marketing-consent-title": "Vill du få exklusiva erbjudanden och nyheter?",
      "marketing-consent-body": "Vi skickar dig erbjudanden och nyheter via notiser, e-post eller SMS. Du kan alltid ändra detta i din profil.",
      "marketing-consent-yes": "Ja tack",
      "marketing-consent-no": "Inte nu",
      "add-payment-title": "Lägg till betalningsmetod",
      "add-payment-body": "Spara en betalningsmetod för enklare bokningar! Vissa resor kräver det.",
      "add-payment-button": "Lägg till betalningsmetod",
      "add-payment-not-now": "Inte nu",
      "add-payment-type-card": "Betalkort",
      "add-payment-type-tsab": "TSAB-konto",
      "button-back": "Tillbaka",
      "button-verify-email": "Verifiera",
      "email-verify-sent-title": "Kolla din inkorg",
      "email-verify-sent-body": "Vi har skickat ett verifieringsmejl till",
      "email-verify-resend-countdown": "Skicka igen ({{seconds}}s)",
      "email-verify-resend": "Skicka igen",
      "button-verify-phone": "Verifiera",
      "phone-verify-sent-title": "Ange din kod",
      "phone-verify-sent-body": "Vi har skickat en kod via SMS till",
      "phone-verify-resend-countdown": "Skicka ny kod ({{seconds}}s)",
      "phone-verify-resend": "Skicka ny kod",
      "phone-verified-title": "Ditt telefonnummer är verifierat",
      "phone-verified-body": "Tack! Ditt telefonnummer är nu bekräftat. Du kan stänga det här fönstret eller logga in för att fortsätta.",
      "error-phone-verify-failed": "Det gick inte att verifiera telefonnumret, var vänlig försök igen",
      "validation-phone-format": "Ange ett giltigt telefonnummer.",
      "label-company": "Företag",
      "label-connected-email": "Företagsmail",
      "label-communications": "Kommunikation",
      "info-change-phone": "För att använda ett annat telefonnummer behöver du logga ut och skapa ett nytt konto.",
      "info-verify-phone": "Om du ändrar ditt telefonnummer skickar vi en kod via SMS för att verifiera det. Numret sparas först när koden är bekräftad.",

      "reset-booking-message": "Vill du verkligen avbryta din bokning?",
      "reset-edit-message": "Vill du verkligen avbryta din ändring?",
      "reset-login-message": "Vill du verkligen avbryta din inloggning?",
      "button-login": "Logga in",
      "button-yes": "Ja",
      "button-no": "Nej",

      "price_basePrice": "Grundpris",
      "price_vat": "Varav moms",
      "price_terminalFee": "Terminalavgift",
      "price_environmentalFee": "Miljöavgift",
      "price_waitingFee": "Väntetaxa",
      "price_fixedAdditionalFee": "Fasta tillägg i bil",
      "price_vehicleOption": "Tillval",
      "price_tip": "Dricks",

      "button-read-more": "Läs mer",

      "status-pre-booked": "Förbokad",
      "status-searching": "Söker bil",

      "status-header-received": "Bokningen är mottagen",
      "status-header-dispatched": "Bilen är på väg",
      "status-header-plate-prefix": "Taxi ",
      "status-header-dispatched-suffix": " är på väg",
      "status-header-approaching": "Bilen är nästan framme",
      "status-header-approaching-suffix": " är nästan framme",
      "status-header-at-pickup": "Din bil är framme",
      "status-header-at-pickup-suffix": " är framme",
      "status-header-en-route": "Trevlig resa",
      "status-header-completed": "Utförd",
      "status-header-cancelled": "Avbeställd",
      "status-header-no-show": "Ej kundkontakt",
      "status-header-rejected": "Bokning nekad",
      "status-header-failed": "Ej bokad",
      "status-header-cancellation-requested": "Avbokning begärd",
      "status-header-cancellation-rejected": "Avbokning nekad",
      "status-header-annulled": "Anullerad",
      "status-subtitle-received": "Vi har tagit emot din bokning, en bil är snart på väg",
      "status-subtitle-searching": "Vi har snart en bil på väg",
      "status-subtitle-prebooked": "Din bokning är bekräftad",
      "status-subtitle-dispatched": "Din taxi hämtar snart upp dig",
      "status-subtitle-dispatched-with-address": "Taxin kommer att hämta dig på {{address}}",
      "status-subtitle-approaching-with-address": "Taxin kommer att hämta dig på {{address}}",
      "status-subtitle-at-pickup": "Din bil är framme",
      "status-subtitle-at-pickup-with-address": "Taxin väntar vid {{address}}",
      "status-subtitle-en-route": "Trevlig resa!",
      "status-subtitle-en-route-with-destination": "Taxin kör dig till {{destination}}",
      "status-subtitle-completed": "Tack för att du valt att resa med Taxi Stockholm",
      "status-subtitle-cancelled": "Din resa är avbokad",
      "status-subtitle-no-show": "Din resa är avbokad",

      "status-waiting-for-confirmation": "Bokningen är mottagen",

      "menu-my-bookings": "Mina resor",
      "header-previous-bookings": "Tidigare resor",

      "button-book-taxi": "Boka taxi",
      "button-book-delivery": "Boka bud",

      "label-as-soon-as-possible": "Så snart som möjligt",
      "label-price": "Pris",

      "header-book-delivery": "Boka bud",
      "placeholder-pickup-address": "Upphämtningsadress",
      "placeholder-delivery-address": "Leveransadress",
      "button-prebook-delivery": "Förboka bud",
      "button-book-delivery-now": "Boka bud nu",
      "validation-pickup-address-required": "Du måste välja en upphämtningsadress.",
      "validation-delivery-address-required": "Du måste välja en leveransadress.",

      "header-when-should-we-pickup": "När ska vi hämta?",

      "header-what-would-you-like-to-send": "Vad vill du skicka?",
      "title-ENVELOPE": "Kuvert",
      "title-BOX": "Liten låda",
      "title-BAG": "Kasse",
      "title-MOVING_BOX": "Flyttlåda",
      "weight-0-20": "Vikt 0-20 kg",
      "info-delivery-categories": "Ovanstående kategorier används för att avgöra vilken biltyp som kommer att behövas för ditt bud (max bilstorlek är kombi).",
      "info-delivery": "Om du vill skicka mer skrymmande gods eller har frågor, ring vår budväxel på 08-612 60 00.<br/> Mer information om vad som gäller för budbokning via webb hittar du <button1>här</button1>.",
      "info-delivery-terms": "<strong>Mer information om bud via vår hemsida</strong><br/><br/><ul><li>Vår budservice hanterar ej farligt gods (tex bensin, cigarettändare, gasol), varmhållen mat, tobak, djur eller större flyttransporter.</li><li>Maxvikt per kolli är 20 kg vid budbokning via vår hemsida.</li><li>10 min väntetid ingår i priset för budbokning, därefter debiteras väntetaxa.</li><li>Ev. färjeavgift kan tillkomma om rutten innefattar en färja med avgift.</li><li>Ev. terminalavgifter är inkluderade i priset för vissa destinationer. Se aktuella prisuppgifter för terminalavgifter <a href=\"/sv/hjalpcenter/priser\" target=\"_blank\">här</a>.</li><li>I de fall föraren inte är tillåten att lämna godset vid dörren och mottagaren ej är tillgänglig vid avlämning, kommer godset att returneras till sändaren. En ev. returresa debiteras.</li><li>Vid betalningsmetod Betala i taxin, så måste resan betalas av avsändaren innan den påbörjas.</li><li>Vi kan tyvärr inte hjälpa till med inköp av varor.</li><li>Vi kan tyvärr inte hämta ut paket där legitimation krävs.</li><li>Sätet i bilen kommer tyvärr inte att kunna fällas ner vid budbokning via hemsidan. Om du vill skicka skrymmande gods (gods med stor volym/mått) eller har frågor, kontakta vår budväxel på 08-612 60 00.</li></ul>",
      "validation-package-required": "Du måste välja åtminstone en typ av bud du vill skicka.",

      "header-whos-the-sender": "Vem skickar?",
      "placeholder-name-on-door": "Namn på dörren",
      "placeholder-number-of-stairs": "Antal trappor",
      "placeholder-door-code": "Eventuell portkod",

      "header-whos-the-receiver": "Vem tar emot?",
      "placeholder-name-receiver-on-door": "Namn mottagare / på dörren",
      "placeholder-phone-receiver": "Telefon mottagare",
      "title-extra-information": "Extra information",
      "info-extra-information": "Här kan du fylla i extra information till föraren.",
      "title-leave-outside": "Lämna utanför",
      "validation-name-receiver-required": "Du måste fylla i namn på mottagare.",

      "label-name-on-door": "Namn på dörren",
      "label-number-of-stairs": "Antal trappor",
      "label-door-code": "Eventuell portkod",
      "label-name-receiver-on-door": "Namn mottagare / på dörren",
      "label-phone-receiver": "Telefon mottagare",
       
      "type-ENVELOPE": "{{count}} kuvert",
      "type-BOX_one": "{{count}} liten låda",
      "type-BOX_other": "{{count}} små lådor",
      "type-BAG_one": "{{count}} kasse",
      "type-BAG_other": "{{count}} kassar",
      "type-MOVING_BOX_one": "{{count}} flyttlåda",
      "type-MOVING_BOX_other": "{{count}} flyttlådor",

      "header-account": "Konto",
      "header-accounts": "Konton",
      "header-card": "Betalkort",
      "header-cards": "Betalkort",
      "header-vouchers": "Rabattkoder",
      "info-no-accounts": "Du har inte lagt till några konton ännu.",
      "info-no-cards": "Du har inte lagt till några betalkort ännu.",
      "info-no-vouchers": "Du har inte lagt till några rabattkoder ännu.",
      "header-no-payment-methods": "Ingen betalmetod tillagd",
      "info-no-payment-methods": "Den här resan kräver förbetalning. Lägg till en betalmetod för att fortsätta.",
      "button-add-payment": "Lägg till betalmetod",
      "button-add-card": "Lägg till betalkort",
      "button-add-account": "Lägg till konto",
      "button-add-voucher": "Lägg till rabattkod",
      "button-save": "Spara",
      "info-confirm-remove-card": "Är du säker på att du vill ta bort betalkortet från din profil?",
      "header-add-account": "Lägg till konto",
      "header-add-voucher": "Lägg till rabattkod",
      "header-details": "Uppgifter",
      "placeholder-account-number": "Kontonummer",
      "placeholder-account-password": "Lösenord",
      "placeholder-voucher-code": "Rabattkod",
      "validation-need-voucher-code": "Du måste ange en kod.",
      "validation-need-account-number": "Du måste ange kontonummer.",
      "validation-need-account-password": "Du måste ange lösenord.",
      "expires-at": "Giltig t.o.m {{date}}",
      "free-trip": "Gratis resa*",
      "info-voucher-max": "Rabatt på första {{amount}}kr",
      "info-voucher-codes": "Det är bara möjligt att använda en rabattkod per resa. Se våra <link1>betalningsvillkor</link1> för mer information.",
      "info-voucher-codes-partner": "Rabattkoder kan ej användas vid bokning med partners. Se våra <link1>betalningsvillkor</link1>.",
      "info-voucher-disabled-payment-method": "Rabattkoder kan inte användas med denna betalningsmetod.",
      "info-voucher-disabled-provider": "Rabattkoder kan inte användas med denna partner.",
      "info-voucher-disabled-taxameter": "Rabattkoder kan inte användas med taxameter.",

      "button-send-confirmation": "Epostbekräftelse",
      "header-send-confirmation": "Skicka epostbekräftelse",
      "placeholder-email": "Epostadress",
      "button-send": "Skicka",
      "info-confirmation-sent": "En bekräftelse har skickats.",
      "label-important-about-your-trip": "Viktig information om din resa"
    }
  },
  "en": {
    "translation": {
      "your-trip": "Your trip",
      "edit-your-trip": "Edit your trip",
      "edit-fields-expiration-warning": "Some fields will be disabled for editing in {{time}}",
      "edit-fields-expiration-subtext": "Save your changes or they may be locked",
      "edit-fields-no-changes-title": "Cannot Make Changes",
      "edit-fields-no-changes-message": "It is no longer possible to make any changes to this booking.",
      "header-where-do-you-want-to-go": "Where do tou want to go?",
      "header-book-taxi": "Book taxi",
      "placeholder-origin-location": "Where can we pick you up?",
      "placeholder-destination-location": "Where do you want to go?",
      "placeholder-add-stop": "Add a stop",
      "button-add-stop": "Add a stop",
      "button-go-now": "Book taxi now",
      "button-go-later": "Pre-book",
      "button-no-available-cars": "No available cars",
      "booking-login-info": "To complete your booking, you will be required to verify your phone number.",
      "validation-departure-required": "You must select a pickup location.",
      "validation-destination-required": "You must select a destination.",
      "validation-airport-not-allowed": "You cannot select an airport as an intermediate stop.",
      "validation-departure-invalid": "We can't pickup at this location",
      "validation-destination-invalid": "We can't stop at this location",
      "validation-intermediate-invalid": "Not valid as intermediate stop",
      "info-enter-street-number": "Please enter the<br/>street number",
      "error-no-estimate": "It seems like you have a bad connection, please try again or call our exchange 08-15 00 00 and they will help you book.",
      "info-select-redirect": "Please select an alternative location.",

      "header-when-do-you-want-to-go": "When can we pick you up?",
      "header-when-does-your-flight-land": "When will your flight arrive?",
      "flightnumber-info": "You can usually find your flight number on your ticket or booking confirmation.",
      "button-continue": "Continue",
      "placeholder-flight-number": "Flight number",
      "placeholder-pick-date": "Pick landing time",
      "info-flight-number": "We will monitor your flight arrival time",
      "title-baggage": "Checked Baggage",
      "info-baggage": "We take into account that it may take time to receive your checked baggage after landing",
      "section-flight-number": "Flight number",
      "section-landing-time": "Landing time",
      "section-luggage": "Luggage",
      "header-passengers": "Passengers",
      "label-passenger-count": "{{count}} passengers",
      "label-group-size": "How many in your group?",
      "info-passenger-count": "The provider needs to know how many passengers you will be in the car. You may share this ride with other passengers.",
      "validation-need-passenger-count": "Enter number of passengers",
      "modal-passenger-required-title": "Passengers required",
      "modal-passenger-required-body": "Please enter how many passengers are travelling with you.",
      "validation-date-not-valid": "Date and time is not valid.",
      "validation-date-too-far-ahead": "Date and time too far ahead.",
      "validation-need-date": "You need to select a day and time.",
      "validation-need-flight-number": "Please enter a valid flight number (e.g., AB123, A1B234, 1A999Z)",
      "title-invalid-time": "Invalid time",
      "message-invalid-time": "The selected time is not available and has been adjusted to the nearest valid time.",
      "title-fully-booked": "The time is fully booked",
      "message-select-other-time": "The time is fully booked. At the moment pre-bookings are fully booked at least one hour ahead, if possible select another time or call ourcustomer service on 08-15 00 00.",
      "message-select-next-available-time": "Please pick another time or the suggested next available time.<br/><br/>The next available time is {{time}}",
      "button-select-other-time": "Pick another time",
      "button-select-available-time": "Pick suggested time",
      "button-ok": "Ok",

      "header-how-do-you-want-to-go": "Select your trip details",
      "header-select-car": "Select car",
      "header-select-partner": "Select partner",
      "header-no-providers-found": "No providers found",
      "info-no-providers-found": "No provider matches your current selection. Try changing add-ons or car type.",
      "cartype-taxi": "Standardtaxi",
      "cartype-large-car": "People carrier",
      "cartype-estate": "Estate",
      "cartype-business": "Business",
      "cartype-taxi-info": "For your everyday needs",
      "cartype-large-car-info": "For bigger groups",
      "cartype-estate-info": "More cargo space",
      "cartype-business-info": "Premium cars",
      "num-persons-3": "3 persons",
      "num-persons-4": "4 persons",
      "num-persons-7": "7 persons",
      "approx-min": "about {{minutes}} min",
      "title-fixed-price": "Fixed price",
      "info-fixed-price-not-available": "Fixed price is not available",
      "info-taxameter-not-available": "Taxameter is not available",
      "title-private-or-company": "Private or company trip",
      "info-private": "Private",
      "title-booking-options": "Extras",
      "info-booking-options": "Add extra options",
      "label-luggage-fits": "Unsure if your luggage fits?",
      "title-pet-option": "Pet",
      "title-low-option": "Low car",
      "info-low-option": "Easier to get in and out",
      "info-pet-option": "Consider selecting a larger car if needed",
      "title-stationwagon-option": "Estate",
      "title-childseat-option": "Rear-facing child seat",
      "info-childseat-option": "For children 9 months and older or 9kg",
      "title-booster-option": "Booster seat",
      "info-booster-option": "For children over 4 years or 15kg",
      "title-electric-car": "Electric car",
      "info-electric-car": "If available, I prefer an electric car",
      "button-done": "Done",

      "label-i-want-to-go-now": "Direct booking",
      "label-direct-booking": "Direct booking",
      "label-prebooked": "Pre-booking",
      "info-flight-monitoring": "We will monitor your flight arrival time",
      "label-checked-baggage": "Checked baggage",
      "label-from": "From",
      "label-to": "To",
      "label-when": "When",
      "label-payment": "Payment",
      "label-receipt": "Receipt",
      "label-how": "How",
      "label-fixed-price": "Fixed price",
      "label-taxameter": "Taxameter",
      "label-price-information": "Price information",
      "label-total": "Total",
      "label-incl-tip": "incl. tip",
      "label-pet-option": "Pet",
      "label-low-option": "Low car",
      "label-stationwagon-option": "Estate",
      "label-childseat-option": "Rear-facing child seat",
      "label-booster-1-option": "1 booster seat",
      "label-booster-2-option": "2 booster seats",
      "label-electric-option": "Electric car",
      "label-option-free": "Free",
      "label-booking-number": "Booking number",
      "info-available-in": "Available in about {{minutes}} minutes",
      "button-download-receipt": "Show receipt",
      "info-receipt-not-available": "Receipt not available",
      "info-receipt-pending": "Receipt available after registered payment",
      "info-receipt-refunded": "Refund completed",
      "info-num-vouchers_one": "{{count}} available voucher",
      "info-num-vouchers_other": "{{count}} available vouchers",

      "header-welcome": "Welcome!",
      "info-welcome-subtitle": "Travel safely with Stockholm's most experienced taxi company",
      "label-phone-number": "Phone number",
      "button-login-apple": "Continue with Apple",
      "button-login-google": "Continue with Google",
      "button-login-apple": "Continue with Apple",
      "label-or": "or",
      "info-by-continuing-terms": "By continuing, you accept our <link1>Terms & conditions</link1>",

      "header-google-signin": "Sign in with Google",
      "info-google-signin": "Sign in with your Google account to continue.",
      "error-google-signin-failed": "Failed to sign in with Google. Please try again.",
      "error-apple-signin-failed": "Failed to sign in with Apple. Please try again.",

      "header-add-phone-social": "Your phone number",
      "info-add-phone-social": "We use your number in case we need to contact you about your trip. We'll send you a verification link.",
      "info-enter-code-sent-social": "We sent it to number {{dialCode}} {{phone}}",

      "header-is-this-you": "Is this you?",
      "header-login-as": "Log in as {{name}}?",
      "info-existing-account-found": "We found an existing account that uses the same phone number as you entered.",
      "button-not-me": "Not me",
      "button-yes-thats-me": "Yes, that's me",
      "button-create-new-account": "Create new account",

      "header-confirm-phone": "Verify your number",
      "info-confirm-phone": "A code will be sent to your number. We use your number to text you about important updates on your journey.",
      "info-confirm-phone-login": "To login, you must confirm your phone number.",
      "button-cancel": "Cancel",
      "validation-only-numbers": "May only contain numbers.",
      "validation-need-phone": "Phone number can not be empty.",
      "validation-length-phone": "Must be between 6 and 14 digits.",

      "header-enter-your-code": "Please enter your code",
      "info-enter-the-code-sent-to": "We sent it to number {{dialCode}} {{phone}}",
      "button-did-not-get-code": "Resend code",

      "header-enter-your-email": "What’s your email?",
      "placeholder-enter-your-email": "Enter your email address",
      "info-we-use-your-email": "We use your email to sign you in. We’ll send you a verification link.",
      "validation-invalid-email": "Invalid email address.",
      "validation-need-email": "You must enter an email address.",

      "header-welcome-back": "Welcome back!",
      "info-your-phone-is-linked": "Your phone number is linked to the email address {{maskedEmail}}. Please enter the verification code we emailed you.",
      "button-select-other-email": "Use a different email",
      "change-email-message": "If you sign in with a new email, your bookings made with the previous email will not show in your history.",

      "header-enter-name": "What’s your name?",
      "info-driver-confirm-pickup": "This helps our driver confirm it's you when they pick you up.",
      "placeholder-firstname": "First name",
      "placeholder-lastname": "Last name",
      "validation-need-firstname": "You need to fill in first name.",
      "validation-need-lastname": "You need to fill in last name.",

      "header-terms-and-conditions": "Terms and conditions",
      "info-accept-terms": "Please read and accept our <link1>terms and conditions</link1>.",
      "title-accept-terms": "I confirm that I have read and accept the terms and conditions",
      "title-accept-marketing": "I want to receive offers, news and updates from Taxi Stockholm",
      "button-confirm": "Confirm",

      "header-confirm-your-booking": "Confirm your booking",
      "header-confirm-edit": "Confirm changes",
      "placeholder-name": "Name",
      "placeholder-phone": "Phone number",
      "title-payment": "Payment",
      "title-vouchers": "Vouchers",
      "title-voucher": "Voucher:",
      "title-pay-in-car": "Pay in car",
      "title-pay-in-car-sender": "Pay in car (sender pays)",
      "button-add-new-card": "Add new payment card",
      "button-add-new-account": "Add new account",
      "button-add-new-voucher": "Add new voucher",
      "title-message-to-driver": "Message to the driver",
      "placeholder-reference": "Reference",
      "info-accept-booking-terms": "By traveling with us, you accept our <link1>terms and conditions</link1>.",
      "title-message": "Message to the driver",
      "info-message-to-driver": "Here you can clarify how the driver may find you.",
      "validation-need-name": "Name can not be empty.",
      "validation-need-reference": "You need to fill in reference.",
      "validation-need-payment": "You need to choose a payment method.",
      "button-book-now": "Confirm",
      "button-confirm-edit": "Confirm changes",
      "error-payment": "Something went wrong with the payment. Please try again.",
      "error-network": "Could not reach the server. Check your connection and try again.",
      "error-network-uncertain": "We could not confirm whether your booking went through. Please check your active bookings before booking again.",

      "header-whos-travel": "Traveler",
      "button-edit-booking": "Edit booking",
      "button-cancel-booking": "Cancel booking",
      "button-close": "Close",
      "button-book-again": "Book trip again",
      "button-return-trip": "Book return trip",
      "button-add-to-calendar": "Add to calendar",
      "button-forward-confirmation": "Forward booking confirmation",
      "button-modify-booking": "Modify booking",
      "button-receipt-unavailable": "Receipt not available",
      "header-price-change": "Price has changed",
      "info-price-change": "The new price for your booking is {{newPrice}} kr. Do you want to accept the new price?",
      "button-accept-price": "Accept new price",
      "button-reject-price": "Cancel",
      "label-name": "Name",
      "label-phone": "Phone number",
      "label-message-to-driver": "Message to the driver",
      "header-thanks-for-your-booking": "Thank you for your booking!",
      "info-booking-done": "You will find your bookings under the yellow icon at the top right. By traveling with us, you agree to our <link1>terms and conditions</link1>.",
      "title-car-and-eta": "{{taxi}} - ({{vehicle}}) arrives approx. {{eta}}",
      "title-car": "{{taxi}} - ({{vehicle}})",

      "tooltip-here-is-your-bookings": "Here is your bookings",
      "header-your-bookings": "Your bookings",
      "info-arrives-apx": "Approx.",
      "label-date": "Date",
      "label-flight-number": "Flight number",
      "label-baggage": "Baggage",
      "label-account": "Account",
      "label-company-trip": "Company trip",
      "label-private-trip": "Private trip",
      "label-booking-options": "Extras",
      "label-yes": "Yes",
      "label-no": "No",
      "label-message": "Message to the driver",
      "button-show-more": "Show more",
      "button-show-less": "Show less",

      "info-login-to-update-profile": "Log in to add payment methods, view travel history or update your profile.",
      "label-firstname": "First Name",
      "label-lastname": "Last Name",
      "label-mobile-phone": "Mobile phone",
      "label-not-verified": "Not verified",
      "marketing-consent-title": "Want to receive exclusive offers and news?",
      "marketing-consent-body": "We'll send you offers and news via notifications, email or text. You can always change this in your profile.",
      "marketing-consent-yes": "Yes please",
      "marketing-consent-no": "Not now",
      "add-payment-title": "Add a payment method",
      "add-payment-body": "Save a payment method for simpler bookings! Some trips require it.",
      "add-payment-button": "Add payment method",
      "add-payment-not-now": "Not now",
      "add-payment-type-card": "Payment card",
      "add-payment-type-tsab": "TSAB account",
      "button-back": "Back",
      "button-verify-email": "Verify",
      "email-verify-sent-title": "Check your inbox",
      "email-verify-sent-body": "We've sent a verification email to",
      "email-verify-resend-countdown": "Resend email ({{seconds}}s)",
      "email-verify-resend": "Resend email",
      "button-verify-phone": "Verify",
      "phone-verify-sent-title": "Enter your code",
      "phone-verify-sent-body": "We've sent a code by text message to",
      "phone-verify-resend-countdown": "Send new code ({{seconds}}s)",
      "phone-verify-resend": "Send new code",
      "phone-verified-title": "Your phone number is verified",
      "phone-verified-body": "Thanks! Your phone number is now confirmed. You can close this window or log in to continue.",
      "error-phone-verify-failed": "The phone number could not be verified, please try again",
      "validation-phone-format": "Enter a valid phone number.",
      "label-company": "Company",
      "label-connected-email": "Company email",
      "label-communications": "Communications",
      "info-change-phone": "To use a different phone number, you need to log out and create a new account.",
      "info-verify-phone": "If you change your phone number we'll send a code by text message to verify it. The number is saved once the code is confirmed.",

      "reset-booking-message": "Do you really want to cancel your booking?",
      "reset-edit-message": "Do you really want to cancel your changes?",
      "reset-login-message": "Do you really want to cancel your login?",
      "button-login": "Login",
      "button-yes": "Yes",
      "button-no": "No",

      "price_basePrice": "Base price",
      "price_vat": "VAT",
      "price_terminalFee": "Terminal fee",
      "price_environmentalFee": "Environmental fee",
      "price_waitingFee": "Waiting fee",
      "price_fixedAdditionalFee": "Fixed additional fee",
      "price_vehicleOption": "Extra options",
      "price_tip": "Tip",

      "button-read-more": "Read more",

      "status-pre-booked": "Pre-booked",
      "status-searching": "Looking for a car",

      "status-header-received": "Booking received",
      "status-header-dispatched": "The car is on the way",
      "status-header-plate-prefix": "Taxi ",
      "status-header-dispatched-suffix": " is on the way",
      "status-header-approaching": "The car is almost there",
      "status-header-approaching-suffix": " is almost there",
      "status-header-at-pickup": "Your car has arrived",
      "status-header-at-pickup-suffix": " has arrived",
      "status-header-en-route": "Have a nice trip",
      "status-header-completed": "Completed",
      "status-header-cancelled": "Cancelled",
      "status-header-no-show": "No passenger contact",
      "status-header-rejected": "Booking denied",
      "status-header-failed": "Rejected",
      "status-header-cancellation-requested": "Cancellation requested",
      "status-header-cancellation-rejected": "Cancellation denied",
      "status-header-annulled": "Annulled",
      "status-subtitle-received": "We have received your booking, a car is soon on its way",
      "status-subtitle-searching": "We'll soon have a car for you",
      "status-subtitle-prebooked": "Your booking is confirmed",
      "status-subtitle-dispatched": "Your taxi will soon pick you up",
      "status-subtitle-dispatched-with-address": "Your taxi will soon pick you up at {{address}}",
      "status-subtitle-approaching-with-address": "Your taxi will soon pick you up at {{address}}",
      "status-subtitle-at-pickup": "Your car has arrived",
      "status-subtitle-at-pickup-with-address": "Your taxi is waiting at {{address}}",
      "status-subtitle-en-route": "Enjoy your ride!",
      "status-subtitle-en-route-with-destination": "The taxi will take you to {{destination}}",
      "status-subtitle-completed": "Thank you for travelling with Taxi Stockholm",
      "status-subtitle-cancelled": "The trip was cancelled",
      "status-subtitle-no-show": "The trip was cancelled",

      "status-waiting-for-confirmation": "Booking received",

      "menu-my-bookings": "My bookings",
      "header-previous-bookings": "Previous bookings",

      "button-book-taxi": "Book taxi",
      "button-book-delivery": "Book delivery",

      "label-as-soon-as-possible": "As soon as possible",
      "label-price": "Price",

      "header-book-delivery": "Book delivery",
      "placeholder-pickup-address": "Pickup address",
      "placeholder-delivery-address": "Delivery address",
      "button-prebook-delivery": "Pre-book delivery",
      "button-book-delivery-now": "Book delivery&nbsp;now",
      "validation-pickup-address-required": "You must select a pickup address.",
      "validation-delivery-address-required": "You must select a delivery address.",

      "header-when-should-we-pickup": "When should we pick up?",

      "header-what-would-you-like-to-send": "What do you want to send?",
      "title-ENVELOPE": "Envelope",
      "title-BOX": "Small box",
      "title-BAG": "Bag",
      "title-MOVING_BOX": "Moving box",
      "weight-0-20": "Weight 0-20 kg",
      "info-delivery-categories": "The above categories are used to determine the type of car that will be needed for your bid (max car size is station wagon).",
      "info-delivery": "If you want to send more bulky goods or have questions, call our courier service on 08-612 60 00. You can find more information about what applies to courier reservations via the web <button1>here</button1>.",
      "info-delivery-terms": "<strong>More information about our courier service via the website</strong><br/><br/><ul><li>Our courier service does not handle hazardous goods (for example petrol, cigarette lighters), heated food, tobacco, pets or larger moving transports.</li><li>Maximum weight per package is 20 kg when booking is made via our website.</li><li>10 min waiting time is included in the price, after which a waiting fee is charged.</li><li>Ferry fee may be added if the route includes a ferry with a fee.</li><li>Terminal fees are included in the price for some destinations. See current price information for terminal fees <a href=\"/en/helpdesk/fares-and-payment\" target=\"_blank\">here</a>.</li><li>In case the driver is not allowed to leave the goods at the door and the recipient is not available for delivery, the goods will be returned to the sender. The return trip will be charged.</li><li>If payment method Pay in car is selected, the payment has to be made by the sender before the trip is started.</li><li>We will not be able to help with purchase of any goods as part our service.</li><li>We will not be able to pick up packages where identification is required.</li><li>It will not be possible to fold the seat when booking is made via our website. If you want to send bulky goods (goods with large volume/dimensions) or have questions, contact our courier service on 08-612 60 00 and they will help you.</li></ul>",
      "validation-package-required": "You must select at least one type you want to send.",

      "header-whos-the-sender": "Who is the sender?",
      "placeholder-name-on-door": "Name on door",
      "placeholder-number-of-stairs": "Number of stairs",
      "placeholder-door-code": "Door code",

      "header-whos-the-receiver": "Who is the receiver?",
      "placeholder-name-receiver-on-door": "Receiver name / name on door",
      "placeholder-phone-receiver": "Receiver phone",
      "title-extra-information": "Extra information",
      "info-extra-information": "Here you can enter extra information for the driver.",
      "title-leave-outside": "Leave outside",
      "validation-name-receiver-required": "You must enter the name of the receiver.",

      "label-name-on-door": "Name on door",
      "label-number-of-stairs": "Number of stairs",
      "label-door-code": "Door code",
      "label-name-receiver-on-door": "Receiver name / name on door",
      "label-phone-receiver": "Receiver phone",

      "type-ENVELOPE_one": "{{count}} envelope",
      "type-ENVELOPE_other": "{{count}} envelopes",
      "type-BOX_one": "{{count}} small box",
      "type-BOX_other": "{{count}} small boxes",
      "type-BAG_one": "{{count}} bag",
      "type-BAG_other": "{{count}} bags",
      "type-MOVING_BOX_one": "{{count}} moving box",
      "type-MOVING_BOX_other": "{{count}} moving boxes",

      "header-account": "Account",
      "header-accounts": "Accounts",
      "header-card": "Payment card",
      "header-cards": "Payment cards",
      "header-vouchers": "Vouchers",
      "info-no-accounts": "You have not added any accounts yet.",
      "info-no-cards": "You have not added any payment cards yet.",
      "info-no-vouchers": "You have not added any vouchers yet.",
      "header-no-payment-methods": "No added payment method",
      "info-no-payment-methods": "This trip requires pre-payment. Add a payment method to continue.",
      "button-add-payment": "Add payment",
      "button-add-card": "Add payment card",
      "button-add-account": "Add account",
      "button-add-voucher": "Add voucher",
      "button-save": "Save",
      "info-confirm-remove-card": "Are you sure you want to remove the payment card from your profile?",
      "header-add-account": "Add account",
      "header-add-voucher": "Add voucher",
      "header-details": "Details",
      "placeholder-account-number": "Account number",
      "placeholder-account-password": "password",
      "placeholder-voucher-code": "Voucher code",
      "validation-need-voucher-code": "You have to enter a code.",
      "validation-need-account-number": "You have to enter an account number.",
      "validation-need-account-password": "You have to enter the password.",
      "expires-at": "Expires {{date}}",
      "free-trip": "Free ride*",
      "info-voucher-max": "Discount on first {{amount}}kr",
      "info-voucher-codes": "It's only possible to use one voucher per trip. Please see our <link1>payment terms</link1> for more information.",
      "info-voucher-codes-partner": "Vouchers can’t be used when booking with partners. Please see our <link1>payment terms</link1>.",
      "info-voucher-disabled-payment-method": "Vouchers can not be used with this payment method.",
      "info-voucher-disabled-provider": "Vouchers can not be used with this provider.",
      "info-voucher-disabled-taxameter": "Vouchers can not be used with taximeter.",

      "button-send-confirmation": "Email confirmation",
      "header-send-confirmation": "Send email confirmation",
      "placeholder-email": "Email address",
      "button-send": "Send",
      "info-confirmation-sent": "A confirmation has been sent.",
      "label-important-about-your-trip": "Important about your trip"
    }
  }
}

